export var ultraFast = '50ms';
export var faster = '100ms';
export var fast = '150ms';
export var normal = '200ms';
export var slow = '300ms';
export var slower = '400ms';
export var ultraSlow = '500ms';
//# sourceMappingURL=durations.js.map
